import Balloon from './Balloon'
import { UPWORK } from '../constants/site'

// Verbatim from completed Upwork contracts. Clients stay anonymous; the caption names the job.
const REVIEWS = [
  {
    quote:
      'Whenever I need anything uplifted on any of my sites, I look at no one other than Nikita. He is that good, and I myself am a developer.',
    job: 'Websites Uplift · 2025',
  },
  {
    quote: 'Nikita is the goto guy for anything front end.',
    job: 'Blog styling · 2026',
  },
  {
    quote:
      'Nikita did an excellent job! He quickly understood the issue, demonstrated strong technical expertise, and delivered an effective solution with minimal guidance.',
    job: 'iOS Safari checkout fix · 2026',
  },
  {
    quote: 'I am very lucky to have found such a talented front end developer.',
    job: 'SEO programming · 2025',
  },
]

const Reviews = () => (
  <section aria-labelledby='reviews-title' className='mx-auto max-w-page px-gutter pt-section'>
    <div className='mb-4 flex flex-wrap items-end justify-between gap-x-8 gap-y-2 md:mb-5'>
      <h2 id='reviews-title' className='font-display uppercase text-h2'>
        What clients say
      </h2>
      <p className='lettering pb-1 text-[1.25rem]'>
        Top Rated on{' '}
        <a href={UPWORK} target='_blank' rel='noreferrer' className='underline underline-offset-4'>
          Upwork<span className='sr-only'> (opens in a new tab)</span>
        </a>{' '}
        · 100% Job Success · 26 contracts
      </p>
    </div>

    <ul className='grid gap-tier md:grid-cols-2 lg:grid-cols-12'>
      {REVIEWS.map((r, i) => (
        <li
          key={r.job}
          className={`panel flex flex-col justify-between gap-10 bg-sky p-5 md:p-6 ${i % 3 === 0 ? 'lg:col-span-7' : 'lg:col-span-5'}`}
        >
          <Balloon as='blockquote'>
            <p className='font-letter text-[1.5rem] leading-snug'>{r.quote}</p>
          </Balloon>
          <p className='lettering self-end border-stroke border-line bg-paper px-3 py-1 text-coal'>
            Client on Upwork · {r.job}
          </p>
        </li>
      ))}
    </ul>
  </section>
)

export default Reviews
